module.exports = {
  complete_account_now: 'Complete account now',
  title: 'Competitions',
  ended: 'Finished',
  sign_up: {
    password: 'Password',
    repeat_password: 'Repeat password',
  },
  note: 'Note:',
  note_description: 'You have to fully activate your account in order to take part in challenges and competitions and so that we can notify you in the event of a win.',
  game_counts_for_competition: 'Your results in this category will be evaluated in the current competition "%{competition}." You can find full information on the details page for each competition under the menu item %{menu}.',
}
